import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors globally
// This is a known benign browser timing issue that doesn't affect functionality
// See: https://github.com/WICG/resize-observer/issues/38
if (typeof window !== 'undefined') {
  // Intercept error events before they reach React's error boundary
  const errorHandler = (event) => {
    if (event.message && event.message.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      return true;
    }
  };
  
  // Suppress in window.onerror
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (message && typeof message === 'string' && message.includes('ResizeObserver loop')) {
      return true;
    }
    if (originalOnError) {
      return originalOnError.apply(this, arguments);
    }
    return false;
  };
  
  // Suppress in window error event listener (capture phase)
  window.addEventListener('error', errorHandler, true);
  
  // Suppress unhandled rejections that might be ResizeObserver related
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver')) {
      event.preventDefault();
    }
  });
  
  // Patch ResizeObserver to debounce and prevent loops
  const RO = window.ResizeObserver;
  if (RO) {
    window.ResizeObserver = class PatchedResizeObserver extends RO {
      constructor(callback) {
        let rafId = null;
        const debouncedCallback = (entries, observer) => {
          if (rafId) {
            cancelAnimationFrame(rafId);
          }
          rafId = requestAnimationFrame(() => {
            rafId = null;
            try {
              callback(entries, observer);
            } catch (e) {
              if (!e.message?.includes('ResizeObserver')) {
                throw e;
              }
            }
          });
        };
        super(debouncedCallback);
      }
    };
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
